<template>
  <div class="row mt-4 px-0">
    <div class="col-12">
      <div class="card shadow-sm mb-4">
        <div class="card-header pb-0">
          <h6>최근 이벤트 내역</h6>
        </div>
        <div class="card-body px-4 py-3 mb-3">
          <div class="table-responsive p-0" :style="{ height: minBodyHeight + 'px' }">
            <table class="table align-items-center mb-0">
              <colgroup>
                <col style="width: 10%;">
                <col style="width: 20%;">
                <col style="width: 20%;">
                <col style="width: 15%;">
                <col style="width: 15%;">
                <col style="width: 20%;">
              </colgroup>
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder">No.</th>
                  <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder">EVENT ID</th>
                  <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder">EPC</th>
                  <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder">biz Location</th>
                  <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder">read Point</th>
                  <th class="text-center text-uppercase text-secondary text-xs font-weight-bolder">EVENT TIME</th>
                </tr>
              </thead>

              <tbody>
                <!-- 로딩 -->
                <tr v-if="loading">
                  <td :colspan="6" class="p-0">
                    <slot name="loader">
                      <TableBodyLoader :minHeight="(minBodyHeight-60)" />
                    </slot>
                  </td>
                </tr>

                <!-- 데이터 -->
                <template v-else>
                  <tr v-for="(event, index) in eventList" :key="event.eventID"
                    class="row-hover row-clickable"
                    @click="onRowClick(event)">
                    <td class="text-center text-sm">{{ index + 1 }}</td>
                    <td class="text-center text-sm">
                      <CustomBadge level="very-high" size="sm" :label="event.eventID" />
                      <!-- <soft-badge color="info" variant="gradient" size="sm">{{ event.eventID }}</soft-badge> -->
                    </td>
                    <td class="text-center text-sm epc-cell">
                      <span class="epc-inline">
                        <CustomBadge level="low" size="sm" :label="firstUrn(event)" />
                        <span v-if="extraUrnCount(event) > 0" class="epc-extra">
                          외 {{ extraUrnCount(event) }}건
                        </span>
                      </span>
                    </td>
                    <td class="text-center text-sm">{{ event.bizLocationName }}</td>
                    <td class="text-center text-sm">{{ event.readPointName }}</td>
                    <td class="text-center text-sm">{{ formatDate(event.eventTime) }}</td>
                  </tr>

                  <!-- 비어있음 -->
                  <tr v-if="eventList.length === 0" class="empty-row">
                    <td :colspan="6" class="empty-cell" :style="{ height: (minBodyHeight - 60) + 'px' }">
                      <div class="empty-cell-inner">
                        <div class="empty-center small">{{ emptyMessage }}</div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import SoftBadge from "@/components/SoftBadge.vue";
import TableBodyLoader from "@/components/loading/TableBodyLoader.vue";

export default {
  name: "EventListTable",
  components: { CustomBadge, SoftBadge, TableBodyLoader },
  props: {
    eventList: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    minBodyHeight: { type: Number, default: 360 },
    emptyMessage: { type: String, default: '데이터가 없습니다.' },
  },
  emits: ['row-click'],
  methods: {
    // 문자열/배열 모두 지원, 공백/빈값 제거
    toUrnArray(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.filter(Boolean).map(v => String(v).trim());
      // "a, b, c" 형태 처리
      return String(value)
        .split(",")
        .map(s => s.trim())
        .filter(s => s.length > 0);
    },
    // event.urn 이 있으면 그걸 우선, 없으면 inputUrn 사용
    urnList(event) {
      const primary = this.toUrnArray(event.urn);
      if (primary.length) return primary;
      return this.toUrnArray(event.inputUrn);
    },
    firstUrn(event) {
      const arr = this.urnList(event);
      return arr[0] || "-";
    },
    extraUrnCount(event) {
      const arr = this.urnList(event);
      return Math.max(arr.length - 1, 0);
    },
    onRowClick(item) {
      const id = item?.eventID;
      if (!id) return;
      this.$router.push({ path: `/eventList/detail/${encodeURIComponent(id)}` });
    },
  },
};
</script>

<style scoped>
/* 기존: 전체 tr 고정 높이 */
.table tbody tr {
  height: 52px;
}
.row-hover:hover {
  background-color: rgba(32, 107, 196, 0.06); /* Tabler primary(206bc4) 톤 참고 */
}

.row-clickable {
  cursor: pointer;
}

/* 빈 행은 tr 높이 자동 */
.table tbody tr.empty-row { height: auto; }

/* td 자체는 table-cell 유지 */
.empty-cell { padding: 0; }

/* 여기서 가로/세로 100% 확보 후 중앙정렬 */
.empty-cell-inner {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;     /* 세로 중앙 */
  justify-content: center; /* 가로 중앙 */
}

.empty-center { color: #6c757d; }


</style>
